import { Button, Footer } from "@components/atoms";
import { Title } from "@components/atoms/Title";
import { GardenAccordion } from "@components/molecules";
import { SkeletonRow } from "@components/organism";
import { useHistoryUser } from "./useHistoryUser";

export function HistoryUser() {
    const { history, loading, navigate } = useHistoryUser();

    return (
        <div className="p-4 pb-20 mb-8 flex flex-col gap-4">
            <Title title="• Histórico de alterações" subtitle="Histórico de alterações da conta de Cliente:" />
            <div className="flex flex-col gap-4 max-h-[calc(100vh-200px)] overflow-y-auto">
                {history.map((item, index) => (
                    <GardenAccordion
                        key={index}
                        items={{
                            title: `Alteração #${index + 1}`,
                            content: (
                                <div className="min-h-[200px]">
                                    {[
                                        { label: 'Nome', value: item.actor_name },
                                        { label: 'Data', value: new Date(item.created_at).toLocaleString() },
                                        { label: 'Descrição da alteração', value: item.change_description || '—' },
                                    ].map((field, idx) => (
                                        <div key={idx} className={`grid grid-cols-2 px-4 py-2 text-sm ${idx % 2 === 0 ? 'bg-white' : 'bg-[#F8F9F9]'
                                            }`}>
                                            <span className="text-gray-500 font-medium">{field.label}</span>
                                            <span className='text-gray-700 font-medium text-xs'>{loading ? <SkeletonRow /> : field.value}</span>
                                        </div>
                                    ))
                                    }
                                </div>
                            )
                        }}
                    />
                ))}
            </div>

            <div className='fixed bottom-0 left-0 w-full bg-white p-4 border-t border-gray-200'>
                <Footer>
                    <Button isStretched onClick={() => navigate('/')}>Voltar</Button>
                </Footer>
            </div>

        </div>
    )
}